import { render, staticRenderFns } from "./Hair1.vue?vue&type=template&id=7c6b5a35&"
import script from "./Hair1.vue?vue&type=script&lang=js&"
export * from "./Hair1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports